import React from 'react';
import { sanitizeMarkdownHtml } from './sanitizeHtml';

const escapeHtml = (str) =>
  str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const parseInlineMarkdown = (text) => {
  if (!text) return text;

  // Escape first so any raw HTML in the (model/tool-authored) text is inert;
  // only the tags we emit below can survive, and DOMPurify has final say.
  text = escapeHtml(text);

  text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, linkText, url) =>
    `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">${linkText}</a>`
  );
  text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/__(.*?)__/g, '<strong>$1</strong>');
  text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
  text = text.replace(/_(.*?)_/g, '<em>$1</em>');

  return <span dangerouslySetInnerHTML={{ __html: sanitizeMarkdownHtml(text) }} />;
};

export const parseMarkdown = (text) => {
  if (!text) return text;

  return text.split('\n').map((line, index) => {
    if (line.trim().match(/^[-*]\s/)) {
      return <li key={index} className="ml-4">{parseInlineMarkdown(line.trim().substring(2))}</li>;
    }
    if (line.trim().match(/^\d+\.\s/)) {
      const match = line.trim().match(/^(\d+)\.\s(.*)$/);
      if (match) return <li key={index} className="ml-4">{parseInlineMarkdown(match[2])}</li>;
    }
    if (line.trim().match(/^#{1,3}\s/)) {
      const match = line.trim().match(/^(#{1,3})\s(.*)$/);
      if (match) {
        const Tag = `h${match[1].length + 2}`;
        return <Tag key={index} className="font-semibold mb-1">{parseInlineMarkdown(match[2])}</Tag>;
      }
    }
    if (line.trim()) return <p key={index} className="mb-1">{parseInlineMarkdown(line)}</p>;
    return <br key={index} />;
  });
};
